import React from 'react';
import './PageLayout.css';

export type PageLayoutProps = {
  title: React.ReactNode;
  /** По умолчанию h1; для карточек и дашбордов можно передать h2 */
  titleLevel?: 1 | 2;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
};

/**
 * Единая шапка страницы: заголовок, подзаголовок, действия справа; контент ниже.
 */
export const PageLayout: React.FC<PageLayoutProps> = ({ title, titleLevel = 1, subtitle, actions, children }) => {
  const showSubtitle = subtitle != null && subtitle !== '';
  const TitleTag = titleLevel === 2 ? 'h2' : 'h1';

  return (
    <div className="page-layout">
      <div className="page-layout__shell">
        <header className="page-layout__header">
          <div className="page-layout__heading">
            <TitleTag className="page-layout__title">{title}</TitleTag>
            {showSubtitle ? <p className="page-layout__subtitle">{subtitle}</p> : null}
          </div>
          {actions != null ? <div className="page-layout__actions">{actions}</div> : null}
        </header>
        {children != null ? <div className="page-layout__content">{children}</div> : null}
      </div>
    </div>
  );
};

export default PageLayout;
